/**
 * Идет ли сейчас глава обучения — для кода вне React (боты, эффекты,
 * исполнители шагов), которому нужен весь стор, а не хук.
 *
 * Читает состояние осторожно: у серверного стора матча приватной ветки может
 * не быть вовсе, а обучение — целиком клиентская история.
 *
 * @param {Object} state
 * @returns {boolean}
 */
export const checkIfTutorialActive = (state) => Boolean(state?.private?.tutorial?.chapterId);
